import WithHideCompanyPermissions from './WithHideCompanyPermissions';
import WithHubspotProjectPermissions from './WithHubspotProjectPermissions';
import WithMarkIspPermissions from './WithMarkIspPermissions';

const hasHubspotProjectPermissions = (currentProject, user) => {
  if (currentProject.hubspot_connected === false) {
    return false;
  }

  return user.super_admin || user.hubspot_permissions.includes(currentProject.id);
};


export {
  WithHideCompanyPermissions,
  WithHubspotProjectPermissions,
  WithMarkIspPermissions,
  hasHubspotProjectPermissions,
};



// WEBPACK FOOTER //
// ./src/components/Permissions/index.js